import React, { useCallback } from 'react';
import { Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { NavLink } from 'components/ListSearchPage/PromoArea/primitives';

const PromoNavDesktop = ({ activeCategory, categories, onChangeActiveCategory }) => {
  const onClick = useCallback(
    (category) => {
      onChangeActiveCategory(category);
    },
    [onChangeActiveCategory],
  );

  return (
    <Flex minHeight={65} py={4} ml={4}>
      {categories.map((category) => (
        <NavLink key={category.code} isActive={category.code === activeCategory.code} onClick={() => onClick(category)}>
          {category.name}
        </NavLink>
      ))}
    </Flex>
  );
};

PromoNavDesktop.propTypes = {
  activeCategory: PropTypes.object,
  categories: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, code: PropTypes.string })),
  onChangeActiveCategory: PropTypes.func,
};

PromoNavDesktop.defaultProps = {
  activeCategory: {},
  categories: [],
};

PromoNavDesktop.displayName = 'PromoNavDesktop';

export default PromoNavDesktop;
